// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".r4OFLQOeu5uEBAprRhLc {\r\n    background-color: #202fbb12;\r\n}", "",{"version":3,"sources":["webpack://./src/components/Login.module.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B","sourcesContent":[".loginLayout {\r\n    background-color: #202fbb12;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginLayout": "r4OFLQOeu5uEBAprRhLc"
};
export default ___CSS_LOADER_EXPORT___;
